import { Component, OnDestroy, OnInit } from '@angular/core';
import { FactorTableComponent } from '../../../../_shared/components/factor-table/factor-table.component';
import { FuelKpiRequest } from '../../../../_shared';
import { KpiFactorResponse } from '../../../../_shared/models/fuel-kpi-factor-response.model';
import { FuelChangesService } from '../../../services/fuel-changes.service';
import { Subject } from 'rxjs';
import { ErrorHandlerService } from '../../../../../_shared/services/error-handler.service';

@Component({
  selector: 'app-loss-ratio-modal',
  standalone: true,
  imports: [FactorTableComponent],
  templateUrl: './loss-ratio-modal.component.html',
  styleUrl: './loss-ratio-modal.component.scss'
})
export class LossRatioModal implements OnInit, OnDestroy {
  request: FuelKpiRequest;
  modalFilterHeaders: any;
  factorsData: KpiFactorResponse[] = [];
  formatters = {
    "Loss Ratio": (value: number): string => `${value.toFixed(1)}%`,
    "Net Fuel Retained": (value: number): string => `${value.toFixed(0)}ℓ`,
    "Trend vs Fleet Avg": (value: number): string => `${value.toFixed(1)}%`
  };

  private cancelSubject: Subject<void> = new Subject<void>();

  constructor(
    private fuelChangesService: FuelChangesService,
    private errorHandlerService: ErrorHandlerService
  ) { }

  ngOnInit(): void {
    this.getFuelLossRatioKpiFactors();
  }

  async getFuelLossRatioKpiFactors(): Promise<void> {
    try {
      const response = await this.fuelChangesService.getFuelLossRatioKpiFactors(this.request, this.cancelSubject);
      this.factorsData = response.data ?? [];
    } catch (error: any) {
      this.errorHandlerService.handleError(error);
    }
  }

  ngOnDestroy(): void {
    this.cancelSubject.next();
    this.cancelSubject.complete();
  }
}